<div class="flex h-full max-h-full divide-x overflow-hidden" data-testid="list-container">
  <div class="flex flex-1 flex-col overflow-auto">
    <div class="border-ui-border flex w-full flex-col border-b">
      <div class="flex items-center justify-between">
        <gx-section-title [title]="headline" class="px-sx" />
        @if (isAdmin) {
          <gx-button
            data-testid="download-list-button"
            [text]="'downloadTheList' | translate"
            [title]="'downloadTheList' | translate"
            [icon]="csvExportIcon"
            textClass="hidden md:inline"
            class="mr-4"
            [ngClass]="{ isDownloading: listIsDownloading }"
            [isDisabled]="listIsDownloading"
            (click)="clickOnDownloadList()" />
        }
      </div>
      <p class="px-sx">{{ subheadline }}</p>

      <ng-content select="[filter]"></ng-content>
    </div>

    <ng-content select="[list]"></ng-content>
  </div>

  @if (detailsLoaded) {
    <div @slideInFromRight class="z-4 bg-ui-surface-rise inset-0 flex-1 overflow-auto">
      <ng-content select="[details]"></ng-content>
    </div>
  }
</div>
